export class AudioRecorder {
  private _mediaRecorder: Promise<MediaRecorder>

  ready: Promise<void>
  blob: Promise<Blob>
  stopped: Promise<void>

  constructor() {
    this._mediaRecorder = (async () => {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      return new MediaRecorder(stream)    
    })();
    this.ready = this._mediaRecorder.then(() => {})
    this.blob = new Promise(async (resolve, reject) => {
      try {
        const mediaRecorder = await this._mediaRecorder
        const audioChunks: Blob[] = []
  
        mediaRecorder.ondataavailable = (event) => audioChunks.push(event.data)
        mediaRecorder.onstop = () => {
          const claimedMimeType = mediaRecorder.mimeType
          const mimeType = claimedMimeType || "audio/ogg"
          resolve(new Blob(audioChunks, { type: mimeType }))
        }
  
        mediaRecorder.start()
      } catch (error) {
        console.error('Error accessing microphone:', error);
        reject(error)
      }  
    })
    this.stopped = new Promise(async (resolve, reject) => {
      try {
        const mediaRecorder = await this._mediaRecorder
        mediaRecorder.addEventListener('stop', () => resolve(), {once: true})
      } catch {
        resolve()
      }
    })
  }

  async ensureStopped(): Promise<void> {
    const mediaRecorder = await this._mediaRecorder
    if (mediaRecorder.state !== 'inactive') {
      const stream = mediaRecorder.stream
      mediaRecorder.stop()
      for (const track of stream.getTracks()) {
        track.stop()
        stream.removeTrack(track)
      }
    }
  }

  // Get a MediaStreamSourceNode repeating the recorded signal into the given AudioContext
  async tap(audioContext: AudioContext) {
    return audioContext.createMediaStreamSource((await this._mediaRecorder).stream)
  }

  // Request the mic to provoke a permissions dialog, then immediately release it
  static async probeForPermissions(): Promise<void> {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    for (const track of stream.getTracks()) {
      track.stop()
      stream.removeTrack(track)
    }
  }
}
